import * as React from 'react';

function SvgHomeGray(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#home-gray_svg__clip0_1326_32339)">
        <path
          d="M13.79 6.89L7.752.855 7.348.451a.492.492 0 00-.694 0L.212 6.89a.998.998 0 00-.294.718c.006.55.464.99 1.014.99h.664v5.089h10.81v-5.09h.678a.995.995 0 00.924-.618.995.995 0 00-.219-1.09zm-5.914 5.672h-1.75V9.374h1.75v3.188zm3.404-5.09v5.09H8.877V8.999a.625.625 0 00-.625-.625h-2.5A.625.625 0 005.126 9v3.563H2.72v-5.09h-1.5l5.781-5.776.361.36 5.42 5.417H11.28z"
          fill="#000"
          fillOpacity={0.45}
        />
      </g>
      <defs>
        <clipPath id="home-gray_svg__clip0_1326_32339">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgHomeGray;
